(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4053],{

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 24053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_select_e_box_src; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(28447);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(62062);
// EXTERNAL MODULE: ../packages/ab-context-ebox/src/index.tsx + 3 modules
var ab_context_ebox_src = __webpack_require__(13757);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var ab_text_src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var src = __webpack_require__(2569);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-card-e-box/src/card-e-box.scss
var card_e_box = __webpack_require__(34408);
;// CONCATENATED MODULE: ../packages/ab-card-e-box/src/index.tsx








var CardEBox = function(param) {
    var src = param.src, srcSet = param.srcSet, label = param.label, href = param.href, title = param.title, description = param.description, link = param.link, price = param.price, producto = param.producto, selected = param.selected, i18n = param.i18n;
    // console.log("CardEBox", href, link);
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    var ref = (0,react.useState)(false), viewMore = ref[0], setViewMore = ref[1];
    var ref1 = (0,react.useState)(selected || false), _selected = ref1[0], setSelected = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,ab_context_ebox_src/* useEboxContext */.OI)(), 2), stateEbox = ref2[0], dispatchEbox = ref2[1];
    var addItemToEbox = dispatchEbox.addItemToEbox, resetEbox = dispatchEbox.resetEbox, removeItemFromEbox = dispatchEbox.removeItemFromEbox;
    (0,react.useEffect)(function() {
        setSelected(selected);
    }, [
        selected
    ]);
    if ((producto === null || producto === void 0 ? void 0 : producto.sku) === "EB00032" || (producto === null || producto === void 0 ? void 0 : producto.sku) === "EB00031") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-e-box".concat(_selected ? " selected" : ""),
        onClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (producto) {
                if (_selected) {
                    removeItemFromEbox(producto);
                    setSelected(false);
                } else {
                    addItemToEbox(producto);
                    setSelected(true);
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: href || (link === null || link === void 0 ? void 0 : link.url),
                children: [
                    src ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    srcSet: srcSet,
                                    media: "(max-width: 850px)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: src,
                                    loading: "lazy",
                                    alt: label || title
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "checkbox".concat(_selected ? " selected" : "", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "h1",
                                        children: label
                                    }) : null,
                                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "h1",
                                        className: "title",
                                        children: title
                                    }) : null,
                                    viewMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "span",
                                        className: "description",
                                        children: description
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                                        prefetch: false,
                                        text: viewMore ? t("cerrar") : t("saber-mas"),
                                        style: {
                                            borderWidth: 0,
                                            padding: 0,
                                            textDecoration: "underline",
                                            marginTop: 10
                                        },
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setViewMore(!viewMore);
                                        }
                                    }),
                                    price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "span",
                                        className: "price",
                                        children: "".concat(price)
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }),
            link && (link === null || link === void 0 ? void 0 : link.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                prefetch: false,
                text: (link === null || link === void 0 ? void 0 : link.title) || "Descubrir",
                href: (link === null || link === void 0 ? void 0 : link.href) || (link === null || link === void 0 ? void 0 : link.url),
                target: link.target,
                style: {
                    width: "fit-content"
                }
            }) : null
        ]
    });
};
/* harmony default export */ var ab_card_e_box_src = (CardEBox);

// EXTERNAL MODULE: ../packages/ab-functions/src/index.tsx + 9 modules
var ab_functions_src = __webpack_require__(5134);
// EXTERNAL MODULE: ../packages/ab-select-e-box/src/select-e-box.scss
var select_e_box = __webpack_require__(49681);
// EXTERNAL MODULE: ../node_modules/lodash-es/find.js + 1 modules
var find = __webpack_require__(56232);
// EXTERNAL MODULE: ../node_modules/lodash-es/filter.js + 1 modules
var filter = __webpack_require__(88205);
// EXTERNAL MODULE: ../node_modules/lodash-es/map.js
var map = __webpack_require__(27206);
// EXTERNAL MODULE: ../node_modules/lodash-es/sum.js + 1 modules
var sum = __webpack_require__(17554);
;// CONCATENATED MODULE: ../packages/ab-select-e-box/src/index.tsx













var SelectEbox = function(param) {
    var _title = param.title, title = _title === void 0 ? "Una experiencia gastron\xf3mica" : _title, _text = param.text, text = _text === void 0 ? [] : _text, content = param.content, contenidodebajo = param.contenidodebajo, tipo = param.tipo, product = param.product, products = param.products, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname, animated = param.animated, singleColumn = param.singleColumn, singlecolumn = param.singlecolumn, _element = param.element, element = _element === void 0 ? "h2" : _element, textClass = param.textClass, textclass = param.textclass, _hidePriceDetails = param.hidePriceDetails, hidePriceDetails = _hidePriceDetails === void 0 ? false : _hidePriceDetails, subtitle = param.subtitle, navlink = param.navlink, upsellingModal = param.upsellingModal, i18n = param.i18n;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = (0,react.useState)(1), selected = ref13[0], setSelected = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,ab_context_ebox_src/* useEboxContext */.OI)(), 2), stateEbox = ref14[0], dispatchEbox = ref14[1];
    var itemsEbox = stateEbox.itemsEbox;
    var addItemToEbox = dispatchEbox.addItemToEbox, resetEbox = dispatchEbox.resetEbox, removeItemFromEbox = dispatchEbox.removeItemFromEbox;
    var alojamiento1Noche = (product === null || product === void 0 ? void 0 : (ref = product.configuradorEbox) === null || ref === void 0 ? void 0 : (ref1 = ref.estancias) === null || ref1 === void 0 ? void 0 : ref1.length) ? (ref3 = (0,find/* default */.Z)(product === null || product === void 0 ? void 0 : (ref2 = product.configuradorEbox) === null || ref2 === void 0 ? void 0 : ref2.estancias, function(product) {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.producto) === null || ref === void 0 ? void 0 : ref.sku) == "EB00031";
    })) === null || ref3 === void 0 ? void 0 : ref3.producto : (0,find/* default */.Z)(products, function(product) {
        return (product === null || product === void 0 ? void 0 : product.sku) == "EB00031";
    });
    var alojamiento2Noche = (product === null || product === void 0 ? void 0 : (ref4 = product.configuradorEbox) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.estancias) === null || ref5 === void 0 ? void 0 : ref5.length) ? (ref7 = (0,find/* default */.Z)(product === null || product === void 0 ? void 0 : (ref6 = product.configuradorEbox) === null || ref6 === void 0 ? void 0 : ref6.estancias, function(product) {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.producto) === null || ref === void 0 ? void 0 : ref.sku) == "EB00032";
    })) === null || ref7 === void 0 ? void 0 : ref7.producto : (0,find/* default */.Z)(products, function(product) {
        return (product === null || product === void 0 ? void 0 : product.sku) == "EB00032";
    });
    var _products = (0,filter/* default */.Z)(products, function(product) {
        var ref;
        return (product === null || product === void 0 ? void 0 : product.price) || (product === null || product === void 0 ? void 0 : (ref = product.producto) === null || ref === void 0 ? void 0 : ref.price);
    });
    var myRef = (0,react.useRef)();
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    // console.log("SelectEbox", product?.configuradorEbox?.fijas);
    var precioFijas = (0,map/* default */.Z)(product === null || product === void 0 ? void 0 : (ref8 = product.configuradorEbox) === null || ref8 === void 0 ? void 0 : ref8.fijas, function(fija) {
        var ref, ref1;
        return "".concat((fija === null || fija === void 0 ? void 0 : (ref = fija.producto) === null || ref === void 0 ? void 0 : ref.name) || (fija === null || fija === void 0 ? void 0 : (ref1 = fija.producto) === null || ref1 === void 0 ? void 0 : ref1.sku) || "EB", " - ").concat(numeral_default()(fija === null || fija === void 0 ? void 0 : fija.producto.price).format("1,000[.]00$"));
    });
    // console.log("SelectEbox - products", products, itemsEbox);
    var total1Noche = parseFloat(alojamiento1Noche === null || alojamiento1Noche === void 0 ? void 0 : (ref9 = alojamiento1Noche.price) === null || ref9 === void 0 ? void 0 : ref9.replace(".", "")) + (0,sum/* default */.Z)((0,map/* default */.Z)(product === null || product === void 0 ? void 0 : (ref10 = product.configuradorEbox) === null || ref10 === void 0 ? void 0 : ref10.fijas, function(fija) {
        var ref, ref1;
        return parseFloat(fija === null || fija === void 0 ? void 0 : (ref = fija.producto) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.replace(".", ""));
    }));
    var total2Noches = parseFloat(alojamiento2Noche === null || alojamiento2Noche === void 0 ? void 0 : (ref11 = alojamiento2Noche.price) === null || ref11 === void 0 ? void 0 : ref11.replace(".", "")) + (0,sum/* default */.Z)((0,map/* default */.Z)(product === null || product === void 0 ? void 0 : (ref12 = product.configuradorEbox) === null || ref12 === void 0 ? void 0 : ref12.fijas, function(fija) {
        var ref, ref1;
        return parseFloat(fija === null || fija === void 0 ? void 0 : (ref = fija.producto) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.replace(".", ""));
    }));
    // useEffect(() => {
    //   if (alojamiento1Noche && alojamiento1Noche?.sku) {
    //     addItemToEbox(alojamiento1Noche);
    //   }
    // }, []);
    (0,react.useEffect)(function() {
        if (tipo == "Dias" && selected == 1 && alojamiento1Noche && (alojamiento1Noche === null || alojamiento1Noche === void 0 ? void 0 : alojamiento1Noche.sku)) {
            addItemToEbox(alojamiento1Noche);
        }
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        var slider = document.querySelector(upsellingModal ? "#select-e-box-upselling" : "#select-e-box");
        var myBar = document.querySelector("#myBar");
        var myBarContainer = document.querySelector("#indicator-container");
        var isDown = false;
        var startX;
        var scrollLeft;
        if (slider) {
            var down = function(e) {
                isDown = true;
                // slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            };
            var leave = function() {
                isDown = false;
                slider.classList.remove("active");
            };
            var up = function() {
                isDown = false;
                slider.classList.remove("active");
                slider.classList.remove("prevent-clic");
            };
            var move = function(e) {
                if (!isDown) return;
                e.preventDefault();
                slider.classList.add("active");
                slider.classList.add("prevent-clic");
                var x = e.pageX - slider.offsetLeft;
                var walk = x - startX; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
                if (myBar && myBarContainer) {
                    var percent = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
                    var percentScroll = myBarContainer === null || myBarContainer === void 0 ? void 0 : myBarContainer.clientWidth;
                    myBar.style.left = "".concat(percent * percentScroll, "px");
                }
            };
            slider.addEventListener("mousedown", down);
            // slider.addEventListener('touchstart', down);
            slider.addEventListener("mouseleave", leave);
            // slider.addEventListener('touchcancel', leave);
            slider.addEventListener("mouseup", up);
            // slider.addEventListener('touchend', up);
            slider.addEventListener("mousemove", move);
            // slider.addEventListener('touchmove', move);
            slider.addEventListener("mouseover", function(e) {});
        }
        document.addEventListener("mousemove", function(e) {});
    }, []);
    var myRef2 = (0,react.useRef)();
    var ref15 = (0,es/* useInViewport */.NM)(myRef2, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref15.inViewport, enterCount = ref15.enterCount, leaveCount = ref15.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#".concat(navlink));
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    menu.scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    if ((numeral_default()).locales.abadia === undefined) {
        numeral_default().register("locale", "abadia", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function ordinal(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "€"
            }
        });
    }
    numeral_default().locale("abadia");
    var renderCards = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: upsellingModal && (_products === null || _products === void 0 ? void 0 : _products.length) < 3 ? {
                alignItems: "baseline"
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    id: upsellingModal ? "select-e-box-upselling" : "select-e-box",
                    ref: myRef,
                    children: [
                        _products === null || _products === void 0 ? void 0 : _products.map(function(itm, index) {
                            var ref, ref1, ref2;
                            // console.log("SelectEbox itm", itm);
                            var producto = (itm === null || itm === void 0 ? void 0 : itm.producto) || itm;
                            var selected = (0,filter/* default */.Z)(itemsEbox, function(itemEbox) {
                                var ref;
                                return (itemEbox === null || itemEbox === void 0 ? void 0 : itemEbox.sku) == ((itm === null || itm === void 0 ? void 0 : itm.sku) || (itm === null || itm === void 0 ? void 0 : (ref = itm.producto) === null || ref === void 0 ? void 0 : ref.sku));
                            });
                            // console.log("selected itemsEbox", selected);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_card_e_box_src, {
                                src: (producto === null || producto === void 0 ? void 0 : producto.src) || (producto === null || producto === void 0 ? void 0 : (ref = producto.image) === null || ref === void 0 ? void 0 : ref.mediaItemUrl),
                                srcSet: (producto === null || producto === void 0 ? void 0 : producto.srcSet) || (producto === null || producto === void 0 ? void 0 : (ref1 = producto.imagemobile) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl),
                                label: producto === null || producto === void 0 ? void 0 : producto.label,
                                title: (producto === null || producto === void 0 ? void 0 : producto.title) || (producto === null || producto === void 0 ? void 0 : producto.name),
                                description: producto === null || producto === void 0 ? void 0 : producto.description,
                                href: (0,ab_functions_src/* getTranslation */.i0)({
                                    link: producto === null || producto === void 0 ? void 0 : producto.page
                                }, "uri", {
                                    code: i18n === null || i18n === void 0 ? void 0 : (ref2 = i18n.language) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase()
                                }) || producto.href,
                                link: producto === null || producto === void 0 ? void 0 : producto.link,
                                price: producto === null || producto === void 0 ? void 0 : producto.price,
                                producto: producto,
                                selected: selected === null || selected === void 0 ? void 0 : selected.length
                            }, "ebox-".concat(index));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "spacer",
                            children: " "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "scroll-indicator",
                    id: "indicator-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "scroll-indicator-bar",
                        id: "myBar"
                    })
                })
            ]
        });
    };
    var renderAlojamiento = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "noche".concat(selected == 1 ? " selected" : ""),
                            onClick: function() {
                                setSelected(1);
                                removeItemFromEbox(alojamiento2Noche, alojamiento1Noche);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row-title",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "option",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                            element: "h4",
                                            children: t("1noche")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "span",
                                    className: "disponible",
                                    children: t("disponible")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "span",
                                    className: "disponible",
                                    style: {
                                        fontSize: 17,
                                        marginBottom: 5
                                    },
                                    children: "".concat(numeral_default()(total1Noche).format("1,000[.]00$"))
                                }),
                                !hidePriceDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "span",
                                    className: "disponible",
                                    style: {
                                        fontSize: 11,
                                        marginTop: 0,
                                        marginLeft: 10
                                    },
                                    children: "".concat(t("1nochePrecio"), " - ").concat(numeral_default()(alojamiento1Noche === null || alojamiento1Noche === void 0 ? void 0 : alojamiento1Noche.price).format("1,000[.]00$"))
                                }),
                                !hidePriceDetails && (0,map/* default */.Z)(precioFijas, function(fija) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "span",
                                        className: "disponible",
                                        style: {
                                            fontSize: 11,
                                            marginTop: 0,
                                            marginLeft: 10
                                        },
                                        children: "".concat(fija)
                                    });
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "noche".concat(selected == 2 ? " selected" : ""),
                            onClick: function() {
                                setSelected(2);
                                removeItemFromEbox(alojamiento1Noche, alojamiento2Noche);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row-title",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "option",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                            element: "h4",
                                            children: t("2noches")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "span",
                                    className: "disponible",
                                    children: t("disponible2noches")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "span",
                                    className: "disponible",
                                    style: {
                                        fontSize: 17,
                                        marginBottom: 5
                                    },
                                    children: "".concat(numeral_default()(total2Noches).format("1,000[.]00$"))
                                }),
                                !hidePriceDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "span",
                                    className: "disponible",
                                    style: {
                                        fontSize: 11,
                                        marginTop: 0,
                                        marginLeft: 10
                                    },
                                    children: "".concat(t("2nochesPrecio"), " - ").concat(numeral_default()(alojamiento2Noche === null || alojamiento2Noche === void 0 ? void 0 : alojamiento2Noche.price).format("1,000[.]00$"))
                                }),
                                !hidePriceDetails && (0,map/* default */.Z)(precioFijas, function(fija) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "span",
                                        className: "disponible",
                                        style: {
                                            fontSize: 11,
                                            marginTop: 0,
                                            marginLeft: 10
                                        },
                                        children: "".concat(fija)
                                    });
                                })
                            ]
                        })
                    ]
                }),
                " "
            ]
        });
    };
    if (!singlecolumn && !singleColumn) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                navlink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "reference",
                    style: {
                        top: -90
                    },
                    id: navlink
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "select-e-box horizontal ".concat(className || classname || "").concat(tipo == "Dias" ? " alojamiento" : ""),
                    ref: myRef2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: "h1",
                                    children: subtitle
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                    element: element,
                                    animated: animated,
                                    className: textClass || textclass,
                                    children: title
                                }),
                                contenidodebajo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                    content: contenidodebajo,
                                    singleColumn: true,
                                    className: "no-margin-center"
                                }) : null,
                                text && (text === null || text === void 0 ? void 0 : text.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                    text: text,
                                    content: content,
                                    singleColumn: true
                                }) : null
                            ]
                        }),
                        tipo == "Dias" ? renderAlojamiento() : (_products === null || _products === void 0 ? void 0 : _products.length) ? renderCards() : null
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            navlink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "reference",
                style: {
                    top: -90
                },
                id: navlink
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "select-e-box ".concat(className || classname || ""),
                ref: myRef2,
                children: [
                    subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h1",
                        children: subtitle
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: element,
                        animated: animated,
                        className: textClass || textclass,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        text: text,
                        content: content,
                        singleColumn: singleColumn || singlecolumn
                    }),
                    tipo == "Dias" ? renderAlojamiento() : (products === null || products === void 0 ? void 0 : products.length) ? renderCards() : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        text: text,
                        className: "duplicate",
                        singleColumn: singleColumn || singlecolumn
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_select_e_box_src = (SelectEbox);


/***/ }),

/***/ 34408:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 49681:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);